import {
  ADMIN_ADD_CONSTITUENT_DONATION,
  ADMIN_ADD_USER_DONATION,
  ADMIN_DELETE_CONSTITUENT_DONATION,
  ADMIN_DELETE_USER_DONATION,
  ADMIN_EDIT_CONSTITUENT_DONATION,
  ADMIN_EDIT_USER_DONATION,
  CHECK_AUTHORIZE_STRIPE,
  receiveUrlIntegrationError,
  receiveUrlIntegrationSuccess,
} from "@/components/donations/admin/ducks/Actions"
import {
  apiAdminAddConstituentDonation,
  apiAdminAddUserDonation,
  apiAdminDeleteConstituentDonation,
  apiAdminDeleteUserDonation,
  apiAdminEditConstituentDonation,
  apiAdminEditUserDonation,
  apiCheckAuthorizeStripe,
} from "@/components/donations/admin/ducks/AJAX"
import { NavigationActions } from "@/components/navigation/ducks/slice"
import { receiveCurrentConstituent } from "@/components/profile/admin/ducks/Actions"
import { receiveUpdateUser } from "@/components/profile/ducks/Actions"
import { refetchSearch } from "@/components/search/ducks/Actions"

export default (store) => (next) => (action) => {
  const { dispatch } = store
  const setDonMessage = () => dispatch(NavigationActions.setSnackbar("Donation deleted"))

  const authorizeStripeError = (response) => {
    dispatch(receiveUrlIntegrationError(response))
  }

  const receiveDeleteConstituentDonationSuccess = (refetch, cb) => (response) => {
    dispatch(receiveCurrentConstituent(response.constituent))
    if (refetch) {
      dispatch(refetchSearch(setDonMessage))
    }
    if (cb) {
      cb()
    }
  }

  const receiveDeleteUserDonationSuccess = (response) => {
    dispatch(receiveUpdateUser(response.currentUser))
  }

  const receiveConstituentAddDonationSuccess = (cb) => (response) => {
    dispatch(receiveCurrentConstituent(response.constituent))
    dispatch(refetchSearch())
    if (cb) {
      cb()
    }
  }

  const receiveUserAddDonationSuccess = (_refetch, cb) => (response) => {
    dispatch(receiveUpdateUser(response.currentUser))
    if (cb) {
      cb()
    }
  }

  switch (action.type) {
    case CHECK_AUTHORIZE_STRIPE:
      apiCheckAuthorizeStripe(receiveUrlIntegrationSuccess, authorizeStripeError)
      return next(action)

    case ADMIN_DELETE_USER_DONATION:
      apiAdminDeleteUserDonation(action.donationId, receiveDeleteUserDonationSuccess, action.error)
      return next(action)

    case ADMIN_DELETE_CONSTITUENT_DONATION:
      apiAdminDeleteConstituentDonation(
        action.constituentId,
        action.donationId,
        receiveDeleteConstituentDonationSuccess(true),
        action.error,
      )
      return next(action)

    case ADMIN_ADD_USER_DONATION:
      apiAdminAddUserDonation(
        action.donationAmount,
        action.donationDate,
        receiveUserAddDonationSuccess(true),
        action.error,
      )
      return next(action)

    case ADMIN_EDIT_USER_DONATION:
      apiAdminEditUserDonation(
        action.params,
        action.donationId,
        receiveUserAddDonationSuccess(true, action.success),
        action.error,
      )
      return next(action)

    case ADMIN_EDIT_CONSTITUENT_DONATION:
      apiAdminEditConstituentDonation(
        action.params,
        action.constituentId,
        action.donationId,
        receiveConstituentAddDonationSuccess(action.success),
        action.error,
      )
      return next(action)

    case ADMIN_ADD_CONSTITUENT_DONATION:
      apiAdminAddConstituentDonation(
        action.constituentId,
        action.donationAmount,
        action.donationDate,
        receiveConstituentAddDonationSuccess(action.success),
        action.error,
      )
      return next(action)

    default:
      return next(action)
  }
}
